const de = {
  heading: 'Kunden',
  headingDetailPage: 'Kundenübersicht',
  import: 'Kunden importieren',
  zpId: 'Zahlungspartner-ID',
  drawer: {
    createTitle: 'Neuen Kunden anlegen',
    editTitle: 'Kunden bearbeiten'
  },
  alerts: {
    createFailed: 'Beim Erstellen des Kunden ist ein Fehler aufgetreten.',
    createSuccess: 'Das Erstellen des Kunden war erfolgreich.',
    updateFailed: 'Beim Aktualisieren des Kunden ist ein Fehler aufgetreten.',
    updateSuccess: 'Das Aktualisieren des Kunden war erfolgreich.',
    uploadSuccess: 'Die Datei wurde erfolgreich importiert.'
  },
  validation: {
    ustId: 'Die angegebene UST Id ist nicht gültig',
    ustIdCharacter: 'Eine Ust Id besteht aus 11 Zeichen'
  }
};

export default de;
export type CustomerTranslation = typeof de;
